import { render, staticRenderFns } from "./menutop.vue?vue&type=template&id=f6c8d548&scoped=true&"
import script from "./menutop.vue?vue&type=script&lang=js&"
export * from "./menutop.vue?vue&type=script&lang=js&"
import style0 from "./menutop.vue?vue&type=style&index=0&lang=css&"
import style1 from "./menutop.vue?vue&type=style&index=1&id=f6c8d548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c8d548",
  null
  
)

export default component.exports